import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./resources";

i18n.use(LanguageDetector) // detect user language
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: "it",
        // React already escapes rendered text; leaving i18next's own escaping
        // on turned "D'Amore" into "D&#39;Amore" wherever a name is interpolated.
        interpolation: { escapeValue: false },
    });

export default i18n;
